import { Failure } from '@geekbears/gb-ngrx-stack-base';
import { GetMemberResponse } from '@modules/company-manager/clients/domain/entities/clients.entity';
import { createAction, props } from '@ngrx/store';
import {
  AddCompany,
  AddCompanyResponse,
  Company,
  GetCompaniesResponse,
  GetCompanyByIdResponse,
  UpdateCompany,
  UpdateCompanyResponse,
} from '../../domain/entities/company.entity';
import { ApiQueryParams } from '@utils/api-query-params.type';

/**
 * Actions For All Companies
 */
export const getAllCompaniesAction = createAction(
  '[Company] Get All Companies Action',
  props<ApiQueryParams>()
);
export const getAllCompaniesSuccessAction = createAction(
  '[Company] Get All Companies Success Action',
  props<{
    companies: GetCompaniesResponse;
  }>()
);
export const getAllCompaniesFailureAction = createAction(
  '[Company] Get All Companies Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Get Company By ID
 */
export const getCompanyByIdAction = createAction(
  '[Company] Get Company By Id Action',
  props<{
    companyId: string;
  }>()
);
export const getCompanyByIdSuccessAction = createAction(
  '[Company] Get Company By Id Success Action',
  props<{
    company: GetCompanyByIdResponse;
  }>()
);
export const getCompanyByIdFailureAction = createAction(
  '[Company] Get Company By Id Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Update Company
 */
export const updateCompanyAction = createAction(
  '[Company] Update Company Action',
  props<{
    companyId: string;
    company: UpdateCompany;
  }>()
);
export const updateCompanySuccessAction = createAction(
  '[Company] Update Company Success Action',
  props<{
    response: UpdateCompanyResponse;
  }>()
);
export const updateCompanyFailureAction = createAction(
  '[Company] Update Company Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Remove Member
 */
export const removeMemberAction = createAction(
  '[Company] Remove Member Action',
  props<{
    memberId: any;
  }>()
);
export const removeMemberSuccessAction = createAction(
  '[Company] Remove Member Success Action',
  props<{
    response: any;
  }>()
);
export const removeMemberFailureAction = createAction(
  '[Company] Remove Member Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Get Member By Id
 */
export const getMemberByIdAction = createAction(
  '[Company] Get Member By Id Action',
  props<{
    memberId: any;
  }>()
);
export const getMemberByIdSuccessAction = createAction(
  '[Company] Get Member By Id Success Action',
  props<{
    response: any;
  }>()
);
export const getMemberByIdFailureAction = createAction(
  '[Company] Get Member By Id Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Delete Company
 */
export const deleteCompanyAction = createAction(
  '[Company] Delete Company Action',
  props<{
    companyId: string | undefined;
  }>()
);
export const deleteCompanySuccessAction = createAction(
  '[Company] Delete Company Success Action',
  props<{
    response: {
      data: Company;
    };
  }>()
);
export const deleteCompanyFailureAction = createAction(
  '[Company] Delete Company Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Send Invoice
 */
export const sendInvoiceAction = createAction(
  '[Company] Send Invoice Action',
  props<{
    companyId: string | undefined;
  }>()
);
export const sendInvoiceSuccessAction = createAction(
  '[Company] Send Invoice Success Action',
  props<{
    response: any;
  }>()
);
export const sendInvoiceFailureAction = createAction(
  '[Company] Send Invoice Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Payment History
 */
export const paymentHistoryAction = createAction(
  '[Company] Payment History Action',
  props<{
    companyId: string;
  }>()
);
export const paymentHistorySuccessAction = createAction(
  '[Company] Payment History Success Action',
  props<{
    response: any;
  }>()
);
export const paymentHistoryFailureAction = createAction(
  '[Company] Payment History Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Add Company
 */
export const addCompanyAction = createAction(
  '[Company] Add Company Action',
  props<{
    company: AddCompany;
  }>()
);
export const addCompanySuccessAction = createAction(
  '[Company] Add Company Success Action',
  props<{
    response: AddCompanyResponse;
  }>()
);
export const addCompanyFailureAction = createAction(
  '[Company] Add Company Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Approver By Company ID
 */
export const approversByCompanyIdAction = createAction(
  '[Company] Approver By Company Id Action',
  props<{
    companyId: string;
  }>()
);
export const approversByCompanyIdSuccessAction = createAction(
  '[Company] Approver By Company Id Success Action',
  props<{
    response: GetMemberResponse;
  }>()
);
export const approversByCompanyIdFailureAction = createAction(
  '[Company] Approver By Company Id Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Contact Company
 */
export const contactCompanyAction = createAction(
  '[Company] Approver Contact Company Action',
  props<{
    companyId: string;
  }>()
);
export const contactCompanySuccessAction = createAction(
  '[Company] Approver Contact Company Success Action',
  props<{
    response: any;
  }>()
);
export const contactCompanyFailureAction = createAction(
  '[Company] Approver Contact Company Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Validate Company Name
 */
export const validateCompanyAction = createAction(
  '[Company] Validate Company Action',
  props<{
    companyName: string;
  }>()
);
export const validateCompanySuccessAction = createAction(
  '[Company] Validate Company Success Action',
  props<{
    response: any;
  }>()
);
export const validateCompanyFailureAction = createAction(
  '[Company] Validate Company Failure Action',
  props<{
    failure: Failure;
  }>()
);

export const CompanyActions = {
  /**
   * Actions For Get All Companies
   */
  getAllCompanies: getAllCompaniesAction,
  getAllCompaniesSuccess: getAllCompaniesSuccessAction,
  getAllCompaniesFailure: getAllCompaniesFailureAction,

  /**
   * Actions For Get Company By Id
   */
  getCompanyById: getCompanyByIdAction,
  getCompanyByIdSuccess: getCompanyByIdSuccessAction,
  getCompanyByIdFailure: getCompanyByIdFailureAction,

  /**
   * Actions For Update Company
   */
  updateCompany: updateCompanyAction,
  updateCompanySuccess: updateCompanySuccessAction,
  updateCompanyFailure: updateCompanyFailureAction,

  /**
   * Actions For Remove Member
   */
  removeMember: removeMemberAction,
  removeMemberSuccess: removeMemberSuccessAction,
  removeMemberFailure: removeMemberFailureAction,
  /**
   * Actions For Member By Id
   */
  getMemberById: getMemberByIdAction,
  getMemberByIdSuccess: getMemberByIdSuccessAction,
  getMemberByIdFailure: getMemberByIdFailureAction,
  /**
   * Actions For Delete Company
   */
  deleteCompany: deleteCompanyAction,
  deleteCompanySuccess: deleteCompanySuccessAction,
  deleteCompanyFailure: deleteCompanyFailureAction,
  /**
   * Actions For Send Invoice
   */
  sendInvoice: sendInvoiceAction,
  sendInvoiceSuccess: sendInvoiceSuccessAction,
  sendInvoiceFailure: sendInvoiceFailureAction,

  /**
   * Actions For Send Invoice
   */
  paymentHistory: paymentHistoryAction,
  paymentHistorySuccess: paymentHistorySuccessAction,
  paymentHistoryFailure: paymentHistoryFailureAction,

  /**
   * Actions For Add Company
   */
  addCompany: addCompanyAction,
  addCompanySuccess: addCompanySuccessAction,
  addCompanyFailure: addCompanyFailureAction,

  /**
   * Actions For Approver By Company Id
   */
  approversByCompanyId: approversByCompanyIdAction,
  approversByCompanyIdSuccess: approversByCompanyIdSuccessAction,
  approversByCompanyIdFailure: approversByCompanyIdFailureAction,
  /**
   * Actions For Contact Company
   */
  contactCompany: contactCompanyAction,
  contactCompanySuccess: contactCompanySuccessAction,
  contactCompanyFailure: contactCompanyFailureAction,
  /**
   * Actions For Validate Company Name
   */
  validateCompany: validateCompanyAction,
  validateCompanySuccess: validateCompanySuccessAction,
  validateCompanyFailure: validateCompanyFailureAction,
};
